<script setup lang="ts">
import type { ToasterProps } from '#ui/types';
import type { MetaAttrs } from '@nuxtjs/i18n';
import lodashIncludes from 'lodash-es/includes';

import { Locale } from '~i18n/i18nConfig';

const i18nHead = useLocaleHead();

const filterAlternateLinks = (l: MetaAttrs): boolean => l.rel !== 'alternate' || lodashIncludes(Object.values(Locale), l.hreflang);

useHead({
    titleTemplate: title => {
        return title ? `${title} - Fleequid` : 'Fleequid';
    },
    htmlAttrs: {
        lang: () => i18nHead.value.htmlAttrs!.lang,
    },
    link: () => [...(i18nHead.value.link || []).filter(filterAlternateLinks)],
    meta: () => [...(i18nHead.value.meta || [])],
});
useServerSeoMeta({
    ogImage: {
        url: '/fleequid.jpg',
        type: 'image/jpeg',
        width: '1200px',
        height: '630px',
        alt: 'Fleequid',
    },
    twitterCard: 'summary_large_image',
});
const toaster: ToasterProps = { expand: true, position: 'top-right' };
</script>
<template>
    <UApp :toaster="toaster">
        <NuxtLoadingIndicator
            color="repeating-linear-gradient(to right,var(--ui-color-primary-200) 0%,var(--ui-color-primary-500) 50%,var(--ui-color-primary-900) 100%)"
        />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>
